
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedFullDown as ObiSpeedFullDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-full-down.js';
 
 
 

 
 export const ObiSpeedFullDown = createComponent({
   react: React,
   tagName: 'obi-speed-full-down',
   elementClass: ObiSpeedFullDownElement,
   events: {
     
   }
  });
 
 